import * as React from "react";
import { Route, Switch, RouteComponentProps, withRouter } from "react-router";

import Organisations from "./Organisations/Organisations";
import Locations from "./Locations/Locations";
import Permissions from "./Permissions/Permissions";
import ApplicationPermissions from "./ApplicationPermissions/ApplicationPermissions";
import PermissionGroups from "./PermissionGroups/PermissionGroups";
import PositionManagement from "./PositionManagement/PositionManagement";
import Positions from "./Positions/Positions";
import Crew from "./Crew/Crew";
import Persons from "./Persons/Persons";
import { inject, observer } from "mobx-react";
import { ISearchStore } from "@src/Stores/Search/types";
import FilteredTables from "./FilteredTables/FilteredTables";
import Options from "./Options/Options";
import Api from "./Api/Api";
import AuditLog from "./AuditLog/AuditLog";
import WebSocketSessions from "./WebSocketSessions/WebSocketSessions";
import Themes from "./Themes/Themes";
import Applications from "./Applications/Applications";
import Profile from "../../PersonalSettings/Profile/Profile";
import ChangePassword from "../../PersonalSettings/ChangePassword/ChangePassword";
import QuickLogin from "../../PersonalSettings/QuickLogin/QuickLogin";
import ProfileImage from "../../PersonalSettings/ProfileImage/ProfileImage";
import { IAuthStore } from "@src/Stores/Auth/types";
import { IValuesStore } from "@src/Stores/Values/types";
import { IManagementStore } from "@src/Stores/Management/types";
import { RouterStore } from "mobx-react-router";
import SystemSettings from "./SystemSettings/SystemSettings";
import PositionTeams from "./PositionTeams/PositionTeams";
import OAuth from "./OAuth/Auth";
import SyncLog from "./SyncLog/SyncLog";
import Home from "@src/Components/Pages/Main/Content/Home/Home";
import ApplicationCatalogue
  from "@src/Components/Pages/Main/Content/ApplicationsPage/ApplicationCatalogue/ApplicationCatalogue";
import TwoFactorAuth from "@src/Components/Pages/PersonalSettings/TwoFactorAuth/TwoFactorAuth";

interface IProps extends RouteComponentProps {
  search?: ISearchStore;
  auth?: IAuthStore;
  values?: IValuesStore;
  management?: IManagementStore;
  routing?: RouterStore;
}

@inject("auth", "values", "management", "search", "routing")
@observer
class Content extends React.Component<IProps> {
  async componentDidMount() {
    const { auth, values, management, routing } = this.props;

    if (await auth.Is2FASetupRequired()) {
      routing.history.push("/2fa");
      return;
    }

    const canReviewAudit =
      auth.user.roles?.includes(values.roles.Administrator) ||
      auth.user.roles?.includes(values.roles.Manager);
    if (routing.history.location.pathname !== "/") {
      return;
    } else if (!canReviewAudit) {
      routing.history.push("/");
      return;
    }
    const needReviewAuditLogs = await management.getNeedReviewAuditLogs();
    needReviewAuditLogs.length > 0 && routing.history.push("/audit-log");
  }

  render() {
    if (this.props.search.searchString.length > 0 && this.props.search.entitiesLoaded) {
      return <FilteredTables />;
    }
    return (
      <>
        <Switch>
          <Route path={`${this.props.match.url}application-catalogue`} render={() => <ApplicationCatalogue />} />
          <Route path={`${this.props.match.url}organisations`} render={() => <Organisations />} />
          <Route path={`${this.props.match.url}permissions`} render={() => <Permissions />} />
          <Route path={`${this.props.match.url}app-permissions`} render={() => <ApplicationPermissions />} />
          <Route path={`${this.props.match.url}permission-groups`} render={() => <PermissionGroups />} />
          <Route path={`${this.props.match.url}locations`} render={() => <Locations />} />
          <Route path={`${this.props.match.url}position-management`} render={() => <PositionManagement />} />
          <Route path={`${this.props.match.url}crew`} render={() => <Crew />} />
          <Route path={`${this.props.match.url}position-types`} render={() => <Positions />} />
          <Route path={`${this.props.match.url}position-teams`} render={() => <PositionTeams />} />
          <Route path={`${this.props.match.url}persons`} render={() => <Persons />} />
          <Route path={`${this.props.match.url}options`} render={() => <Options />} />
          <Route path={`${this.props.match.url}system-settings`} render={() => <SystemSettings />} />
          <Route path={`${this.props.match.url}oauth`} render={() => <OAuth />} />
          <Route path={`${this.props.match.url}api`} render={() => <Api />} />
          <Route path={`${this.props.match.url}audit-log`} render={() => <AuditLog />} />
          <Route path={`${this.props.match.url}web-socket-sessions`} render={() => <WebSocketSessions />} />
          <Route path={`${this.props.match.url}themes`} render={() => <Themes />} />
          <Route path={`${this.props.match.url}applications`} render={() => <Applications />} />
          <Route exact path={`${this.props.match.url}profile`} render={() => <Profile />} />
          <Route path={`${this.props.match.url}profile/password`} render={() => <ChangePassword />} />
          <Route path={`${this.props.match.url}profile/pin`} render={() => <QuickLogin />} />
          <Route path={`${this.props.match.url}profile/image`} render={() => <ProfileImage />} />
          <Route path={`${this.props.match.url}2fa`} render={() => <TwoFactorAuth />} />
          <Route path={`${this.props.match.url}`} render={() => <Home />} />
        </Switch>
      </>
    );
  }
}

export default withRouter(Content);
